export default __webpack_public_path__ + "static/media/uogashi.aab0815e.jpeg";